export class Login{
    email:string | undefined;
    password:string | undefined;
    device_name: string | undefined;
}

export class Login_Estatus{
    status: string | undefined;
    message: string | undefined;
    data: User| undefined;
    token: string| undefined;
}

export class User{
    user: users | undefined;
}
export class users{
    nombre:string | undefined;
    apellidos: string | undefined;
    email: string | undefined;
    rol: string | undefined;
    idUser: number  =0;
    password: string | undefined;
}

export class user_autentica{
    email: string | undefined;
    psw: string | undefined;
}

export class user_autentica_bd{
    email: string | undefined;
    password: string | undefined;
}


export class Result{
    nro_respuesta:number | undefined;
    mensaje: string | undefined;
    idUser:number | undefined;
}

 